export default "__VITE_ASSET__JtEtGx6X__"